<script>
  export let label = null;
  export let slug;
  export let buttonGroupClass = 'button-grid-buttons';
  export let buttonList;
  export let selectedIndex;
</script>

{#if label}
  <label class="button-group-label" for={slug}>{label}</label>
{/if}
<div class="{buttonGroupClass}">
  {#each buttonList as obj, idx}
    <button
      name={slug}
      class="toggle {idx === selectedIndex ? 'active' : 'inactive'}"
      data-label={obj.label}
      data-value={obj.value}
      data-index={idx}
      on:click
    >
      {obj.label}
    </button>
  {/each}
</div>

